export default __webpack_public_path__ + "static/media/cardimage8.6bbcc57d.png";